import React from 'react';
import './App.css';
import animatedLogo from './animated-logo.gif';

function App() {
  return (
    <div className="App">
      <div className="maintenance-container">
        <div className="content">
          <div className="icon-wrapper">
            <img src={animatedLogo} alt="Alva Logo" className="maintenance-icon" />
          </div>
          <h1 className="title">Under vedlikehold</h1>
          <p className="message">
            Vi oppdaterer nettsiden og kommer tilbake i ny drakt. 
            Du er hjertelig velkommen til å besøke oss.no på et senere tidspunkt.
          </p>
          <div className="spinner">
            <div className="spinner-inner"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
